var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDeactivated(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 127.71 126.36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".b26d6a29-f6b9-4999-b3dc-14b8f3b7892d{fill:none;stroke:#89a6df;stroke-linecap:round;stroke-linejoin:round;stroke-width:3px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "b3321cc2-4bb0-4c32-8f1d-02f59113a6a0",
    "data-name": "Layer 9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b26d6a29-f6b9-4999-b3dc-14b8f3b7892d",
    d: "M15.75,118.32,64.56,88.83a3.68,3.68,0,0,0,1.76-3.13V37.15A3.65,3.65,0,0,1,68.11,34L112,8"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeactivated);
export default __webpack_public_path__ + "static/media/deactivated.e9183932.svg";
export { ForwardRef as ReactComponent };